import type { RootState } from '@/store/store';

export const selectCurrentBlog = (state: RootState) => state.blog.currentBlog;
export const selectCurrentBlogCategories = (state: RootState) => state.blog.currentBlogCategories;
export const selectCurrentBlogPosts = (state: RootState) => state.blog.currentBlogPosts;
export const selectMyBlogs = (state: RootState) => state.blog.myBlogs;
export const selectMyBlogsLoading = (state: RootState) => state.blog.myBlogsLoading;
export const selectMyBlogsError = (state: RootState) => state.blog.myBlogsError;
export const selectCurrentPost = (state: RootState) => state.blog.currentPost;
export const selectBlogLoading = (state: RootState) => state.blog.loading;
export const selectBlogError = (state: RootState) => state.blog.error;
export const selectBlogPagination = (state: RootState) => state.blog.pagination;
export const selectPostsHasMore = (state: RootState) => state.blog.postsHasMore;
export const selectPostsLoading = (state: RootState) => state.blog.postsLoading;
export const selectPostsPage = (state: RootState) => state.blog.postsPage;
export const selectPostsPageSize = (state: RootState) => state.blog.postsPageSize;
